// Пробрасываем в глобальный скоп настройки из окружения.
window.Settings = Settings

export const settings = Settings
